const U = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;
const M = (id) => `/media/${id}.jpeg`;

export const REGIONS = [
  { id: 'west-central-africa', name: 'West & Central Africa' },
  { id: 'east-africa', name: 'East Africa' },
  { id: 'indian-ocean', name: 'Indian Ocean' },
];

export const LEGACY_DESTINATION_ROUTES = {
  'sao-tome': 'sao-tome-principe/sao-tome',
  'principe': 'sao-tome-principe/principe',
};

export const DESTINATIONS = [
  {
    slug: 'sao-tome-principe',
    name: 'São Tomé & Príncipe',
    country: 'São Tomé e Príncipe',
    region: 'west-central-africa',
    status: 'available',
    flag: 'st',
    img: M('4923818b-7917-45ff-9853-4bb847436818'),
    hero: M('4923818b-7917-45ff-9853-4bb847436818'),
    positioning: 'Cacau, floresta tropical e praias intocadas.',
    categories: ['Culture & Nature', 'Sea', 'Hiking', 'Accommodation', 'Transfers', 'Full Packages'],
    coords: [0.27, 6.62],
    subs: [
      {
        slug: 'sao-tome', name: 'São Tomé', island: 'São Tomé', flag: 'st',
        tags: 'Natureza · Cultura · Cacau', tagline: 'Onde a floresta encontra o oceano.',
        img: U('photo-1662534068962-6b3fa9aed99d'), hero: M('4923818b-7917-45ff-9853-4bb847436818'),
        cta: 'Explorar São Tomé',
        desc: 'A ilha principal do arquipélago: florestas tropicais do Parque Natural do Obô, roças de cacau centenárias, praias desertas e uma cultura crioula vibrante. Cada experiência é conduzida por profissionais locais da nossa rede.',
      },
      {
        slug: 'principe', name: 'Príncipe', island: 'Príncipe', flag: 'st',
        tags: 'Biosfera · Praias · Roças', tagline: 'Natureza em estado puro.',
        img: U('photo-1533760881669-80db4d7b4c15'), hero: U('photo-1590523741831-ab7e8b8f9c7f'),
        cta: 'Descobrir Príncipe',
        desc: 'Reserva Mundial da Biosfera UNESCO: floresta primária intocada, cascatas escondidas, roças históricas e algumas das praias mais bonitas de África, como a icónica Praia Banana.',
      },
    ],
  },
  {
    slug: 'cabo-verde',
    name: 'Cabo Verde',
    country: 'Cabo Verde',
    region: 'west-central-africa',
    status: 'available',
    flag: 'cv',
    img: M('56467cf4-1c33-4530-bae3-1167dc9c64fa'),
    hero: M('56467cf4-1c33-4530-bae3-1167dc9c64fa'),
    positioning: 'Onde a montanha encontra o mar.',
    categories: ['Hiking', 'Culture', 'Sea', 'Gastronomy', 'Accommodation', 'Transfers', 'Full Packages'],
    coords: [15.07, -23.63],
    subs: [
      {
        slug: 'santiago', name: 'Santiago', island: 'Santiago', flag: 'cv',
        tags: 'Montanhas · Oceano · Cultura', tagline: 'Onde a montanha encontra o mar.',
        img: U('photo-1785040512478-738b9f086773'), hero: M('56467cf4-1c33-4530-bae3-1167dc9c64fa'),
        cta: 'Explorar Santiago',
        desc: 'Na ilha de Santiago, onde a montanha encontra o mar: trilhos vulcânicos na Serra Malagueta, a Cidade Velha Património UNESCO, pesca artesanal e a alma crioula da música cabo-verdiana.',
      },
    ],
    futureIslands: ['Santo Antão', 'São Vicente', 'Fogo', 'Sal', 'Boa Vista'],
  },
  {
    slug: 'ghana',
    name: 'Ghana',
    country: 'Ghana',
    region: 'west-central-africa',
    status: 'partner_network',
    flag: 'gh',
    img: U('photo-1516026672322-bc52d61a55d5'),
    hero: U('photo-1516026672322-bc52d61a55d5'),
    positioning: 'Cultura, património e turismo comunitário.',
    categories: ['Culture & Heritage', 'Local Experiences', 'Nature', 'Community Tourism', 'Accommodation', 'Transfers', 'Full Packages'],
    message: 'Experiências locais em preparação. Estamos a desenvolver a nossa rede de parceiros locais no Ghana.',
    cta: 'Descobrir Ghana',
    coords: [7.95, -1.02],
    subs: [],
    placeholderImage: true,
  },
  {
    slug: 'kenya',
    name: 'Kenya',
    country: 'Kenya',
    region: 'east-africa',
    status: 'partner_network',
    flag: 'ke',
    img: U('photo-1547471080-7cc2caa01a7e'),
    hero: U('photo-1547471080-7cc2caa01a7e'),
    positioning: 'Safari, vida selvagem e costa.',
    categories: ['Safari', 'Wildlife', 'Culture', 'Nature', 'Coast', 'Community Experiences', 'Accommodation', 'Transfers', 'Full Packages'],
    message: 'Discover Kenya with local expertise.',
    cta: 'Planear Kenya',
    coords: [0.18, 37.9],
    subs: [],
    placeholderImage: true,
  },
  {
    slug: 'tanzania',
    name: 'Tanzania',
    country: 'Tanzania',
    region: 'east-africa',
    status: 'partner_network',
    flag: 'tz',
    img: U('photo-1516426122078-c23e76319801'),
    hero: U('photo-1516426122078-c23e76319801'),
    positioning: 'De paisagens extraordinárias a comunidades locais e ao Oceano Índico.',
    categories: ['Safari', 'Wildlife', 'Nature', 'Culture', 'Local Communities', 'Zanzibar / Coast', 'Accommodation', 'Transfers', 'Full Packages'],
    message: 'De paisagens extraordinárias a comunidades locais e ao Oceano Índico.',
    cta: 'Planear Tanzania',
    coords: [-6.37, 34.89],
    subs: [],
    futureIslands: ['Zanzibar'],
    placeholderImage: true,
  },
  {
    slug: 'mauritius',
    name: 'Mauritius',
    country: 'Mauritius',
    region: 'indian-ocean',
    status: 'partner_network',
    flag: 'mu',
    img: U('photo-1544550581-5f7ceaf7f992'),
    hero: U('photo-1544550581-5f7ceaf7f992'),
    positioning: 'Descubra a Maurícia através de quem melhor a conhece.',
    categories: ['Island Experiences', 'Beaches', 'Nature', 'Culture', 'Gastronomy', 'Boat Experiences', 'Accommodation', 'Transfers', 'Full Packages'],
    message: 'Descubra a Maurícia através de quem melhor a conhece.',
    cta: 'Explorar Mauritius',
    coords: [-20.2, 57.5],
    subs: [],
    placeholderImage: true,
  },
  {
    slug: 'maldives',
    name: 'Maldives',
    country: 'Maldives',
    region: 'indian-ocean',
    status: 'partner_network',
    flag: 'mv',
    img: U('photo-1514282401047-d79a71a590e8'),
    hero: U('photo-1514282401047-d79a71a590e8'),
    positioning: 'Viva as Maldivas para lá do postal.',
    categories: ['Island Stays', 'Local Islands', 'Resorts', 'Marine Experiences', 'Diving / Snorkeling', 'Boat Experiences', 'Transfers', 'Full Packages'],
    message: 'Viva as Maldivas para lá do postal.',
    cta: 'Explorar Maldives',
    coords: [3.2, 73.2],
    subs: [],
    placeholderImage: true,
  },
];

export const destinationBySlug = (slug) => DESTINATIONS.find((d) => d.slug === slug);
export const subOf = (slug, subSlug) => destinationBySlug(slug)?.subs?.find((s) => s.slug === subSlug);
